import React, { Component } from 'react';
import PropTypes from 'prop-types';

/*
*  -------- IMPORTANT --------
*  If you change this, please browserify the following components:
*  - transactable
* */

export class Modal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrollPosition: null
    };

    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.renderHeader = this.renderHeader.bind(this);
    this.renderSubheader = this.renderSubheader.bind(this);
    this.renderBanner = this.renderBanner.bind(this);
  }

  componentDidMount () {
    const { scrollToBottom = true } = this.props;
    const opts = {
      show: false,
      backdrop: 'static'
    };

    if (false === this.props.allowClickAway) {
      opts.backdrop = 'static';
    }

    // init modal, but don't open
    $(`#${this.props.targetElementId}`).modal(opts);

    if (this.props.show) {
      // first call for modal, let's open it
      this.openModal();
    }

    // let's set the clickaway & close behavior to unmount component
    $(`#${this.props.targetElementId}`).on('hidden.bs.modal', this.closeModal);

    // if a function, like analytic, needs to fire once Modal mounts, call it here
    if (this.props.didMountFunction) {
      this.props.didMountFunction();
    }

    const modalWidth = $('.modal-dialogue').width();
    const screenWidth = screen.width;
    const isFullScreen = modalWidth >= screenWidth || modalWidth !== 0;

    if (isFullScreen) {
      const scrollPosition = $(window).scrollTop();

      // save scroll position of document
      this.setState({
        scrollPosition
      });
    }

    if (isFullScreen && this.props.show && scrollToBottom) {
      // scroll to bottom
      window.scrollTo(0, document.body.scrollHeight);
    }
  }

  componentWillReceiveProps (nextProps) {
    // if top level component says close the modal, then close the modal
    if (!nextProps.show) { return this.closeModal(); }
    // if modal needs to be opened again, let's open it
    if (nextProps.show) { return this.openModal(); }
  }

  componentWillUnmount () {
    $(`#${this.props.targetElementId}`).off('hidden.bs.modal');
  }

  closeModal (event) {
    $(`#${this.props.targetElementId}`).modal('hide');

    const { scrollPosition } = this.state;
    const modalWidth = $('.modal-dialog').width();
    const screenWidth = screen.width;
    const isFullScreen = modalWidth >= screenWidth || modalWidth !== 0;

    // scroll to position if available
    if (scrollPosition && isFullScreen) {
      window.scrollTo(0, scrollPosition);
    }

    if (this.props.closeBehavior) {
      this.props.closeBehavior(event);
    }
  }

  openModal () {
    $(`#${this.props.targetElementId}`).modal();
  }

  renderHeader () {
    if (this.props.filter) {
      return this.props.header;
    }
    const modalType = this.props.modalType;

    switch (modalType) {
    case 'special':
      return <h2>{this.props.header}</h2>;
    case 'trans':
      return <h4>{this.props.header}</h4>;
    default:
      return <h3>{this.props.header}</h3>;
    }
  }

  renderSubheader () {
    switch (this.props.modalType) {
    case 'special':
      return <div className="form-modal">{this.props.subheader}</div>;
    case 'filter':
      return <div>{this.props.subheader}</div>;
    default:
      return <p className="col-xs-offset-1 col-xs-10">{this.props.subheader}</p>;
    }
  }

  renderBanner () {
    const { text, type } = this.props.banner;
    const bannerClass = `text-center header-banner ${type}`;

    return <div className={bannerClass}>{ text }</div>;
  }

  render () {
    let headerCloseIcon;
    let headerClass;
    let headerText = null;
    let subHeaderText = null;
    let banner = null;

    if (this.props.addCloseIcon) {
      headerCloseIcon = <span className="pull-right ico ico-sm icon-close-sidebar" onClick={this.closeModal} />;
    }

    if (this.props.header) {
      headerText = this.renderHeader();
    }

    if (this.props.subheader) {
      subHeaderText = this.renderSubheader();
    }

    if (this.props.banner) {
      banner = this.renderBanner();
    }

    let titleClass, bodyClass;
    if (this.props.filter) {
      titleClass = 'white-bg container-bookings-request';
      bodyClass = 'modal-body modal-body-filter col-xs-12';
      headerClass = 'modal-header text-center col-xs-12 fixed-container form-standard white-bg modal-header-mobile modal-title-positioning';
    } else {
      bodyClass = 'modal-body col-xs-12';
      titleClass = 'modal-title';
      headerClass = 'modal-header text-center col-xs-12';
    }
    return (
        <div id={this.props.modalID} className={`modal-dialogue ${this.props.modalSize} ${this.props.modalClass || ''}`} role="document">
        <div className="modal-content">
          <div className={`${titleClass}`}>
            {
              this.props.filter ?
              <div className="modal-banner inline-block form-standard fixed-container modal-title-positioning"
                style={{ zIndex: '7' }}
              >
                {headerCloseIcon}
              </div> :
              <div className="modal-banner">
                {banner}
                {headerCloseIcon}
              </div>
            }
            {
              this.props.header || this.props.subheader ?
              <div className={headerClass} >
                {headerText}
                {subHeaderText}
              </div> : ''
            }
          </div>
          <div id="modal-body" className={`${bodyClass}`}>
            {this.props.body}
          </div>
          {
            this.props.footer ?
            <div id="modal-footer" className="modal-footer col-xs-12">
              {this.props.footer}
            </div> : null
          }
        </div>
      </div>
    );
  }
}

Modal.defaultProps = {
  show: false,
  header: null,
  subheader: null,
  banner: null,
  filter: false,
  body: null,
  footer: null,
  modalType: 'standard',
  addCloseIcon: true,
  grayHeaderBg: false,
  targetElementId: 'modal-container'
};

Modal.propTypes = {
  addCloseIcon: PropTypes.bool.isRequired,
    show: PropTypes.bool.isRequired,
    modalID: PropTypes.string.isRequired,
    modalSize: PropTypes.oneOf(['sm-size', 'md-size', 'lg-size']).isRequired,
    modalType: PropTypes.oneOf(['special', 'standard', 'trans', 'filter']),
    modalClass: PropTypes.string,
    header: PropTypes.oneOfType([
    PropTypes.string, PropTypes.object
  ]),
    subheader: PropTypes.oneOfType([
    PropTypes.string, PropTypes.object
  ]),
    banner: PropTypes.shape({
    type: PropTypes.string,
    text: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ])
  }),
    filter: PropTypes.bool,
    body: PropTypes.oneOfType([
    PropTypes.string, PropTypes.object
  ]),
    footer: PropTypes.oneOfType([
    PropTypes.string, PropTypes.object
  ]),
    didMountFunction: PropTypes.func,
    closeBehavior: PropTypes.func,
    allowClickAway: PropTypes.bool,
    targetElementId: PropTypes.string,
    scrollToBottom: PropTypes.bool,
};
